import { createFileRoute } from "@tanstack/react-router";
import TmsDevicesComparedPage from "@/pages/learn/TmsDevicesComparedPage";
import { page10 } from "@/pages/learn/learnDataP10";
export const Route = createFileRoute(
  "/learn/tms-devices-compared-saint-neurostar-brainsway-exomind",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Devices Compared: SAINT, NeuroStar, BrainsWay, Exomind",
        },
        {
          name: "description",
          content:
            "NeuroStar, BrainsWay Deep TMS, Magnus SAINT, and Exomind compared by coil design, FDA-cleared indications, protocol, and targeting, plus why DBS is not TMS.",
        },
        {
          property: "og:title",
          content: "TMS Devices Compared: SAINT, NeuroStar, BrainsWay, Exomind",
        },
        {
          property: "og:description",
          content:
            "NeuroStar, BrainsWay Deep TMS, Magnus SAINT, and Exomind compared by coil design, FDA-cleared indications, protocol, and targeting, plus why DBS is not TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/tms-devices-compared-saint-neurostar-brainsway-exomind",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/tms-devices-compared-saint-neurostar-brainsway-exomind",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page10.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsDevicesComparedPage />;
}
